export default "__VITE_ASSET__FUwWE4_8__"